import { Add, Close, Delete, Edit, SearchOutlined } from '@mui/icons-material';
import { Box, Button, FormControl,  MenuItem, Modal, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography, CircularProgress, IconButton, InputAdornment, Avatar  } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from "../../api";
import { toast } from 'sonner';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { parsePhoneNumberFromString } from "libphonenumber-js";
import NoDataFound from "../../components/NoDataFound";
import Loader from "../../components/Loader";
import { useGetAllPermissions } from '../../pages/utils/getAllPermissions';
import { ButtonSx,phoneNumberStyleSx,textFieldSx } from '../../styles/GlobalStyles';
import DeleteMemberModal from '../../components/DeleteMemberModal';
import Navbar from '../../components/Navbar';

const Member = () => {
    const TabHeader = ({ title, subtitle }) => (
            <Box sx={{ mb:2 }}>
                <Typography variant="h5" sx={{ fontWeight: 600, mb: 1, color: 'black', fontSize: '24px' }}>{title}</Typography>
                <Typography variant="body1" sx={{ color: '#7c7c83', fontWeight: 500, fontSize: '16px' }}>{subtitle}</Typography>
            </Box>
        );
    const { company_id: id } = useParams();
    const token = JSON.parse(localStorage.getItem("token")).token;
    const [members, setMembers] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalDocuments, setTotalDocuments] = useState(0);
    const [error, setError] = useState(""); // Error message state
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dataLoading, setDataLoading] = useState(true); // Add this state for table loading
    const [formData, setFormData] = useState({
        name: '',
        phonenumber: '',
        email: '',
        Role: '',
        Organization: id,
    });
    const [deleteModal, setDeleteModal] = useState(false);
    const [userId, setUserId] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedMember, setSelectedMember] = useState({
        Name: '',
        Phone: '',
        Email: '',
        Role: '',
    });
    const [search, setSearch] = useState("");
    const [nameError, setNameError] = useState("");
    const [userRole] = useState(() => localStorage.getItem("Role"));
    const { permissions, permissionsLoading, getAllPermissions } = useGetAllPermissions();

     useEffect(() => {
       getAllPermissions();
     }, [token]);

    const handleEditUser = (member) => {
        setSelectedMember(member);
        setIsModalOpen(true);
    };

    const handleInputChange = (e) => {
        setSelectedMember({ ...selectedMember, [e.target.name]: e.target.value });
    };
    const handlePhoneNumberInputChange = (value, country) => {
            if (!value) {
                        setError(`Please enter a phone number for ${country.name}.`);
                        return;
                    }
            
                    try {
                        const phoneNumber = parsePhoneNumberFromString("+" + value.toString(), (country.countryCode).toUpperCase());    
                        // Check if phone number is valid
                        if (!phoneNumber || !phoneNumber.isValid()) {
                            setError(`Invalid phone number format for ${country.name}.`);
                        } else {
                            setError(""); // Clear error if valid
                        }
                    } catch (error) {
                        setError(`Invalid input. Please check the phone number for ${country.name}.`);
                    }
        setFormData({ ...formData, phonenumber: value });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        if (name === "name") {
            if (!/^[\p{L}]+([-'\s][\p{L}]+)*$/u.test(value)) {
              setNameError("Only alphabetic characters are allowed, and spaces cannot be at the beginning or end.");
            } else {
              setNameError("");
            }
          }
    };

    const updateUser = async (e) => {
        e.preventDefault();
        setLoading(true);
        const { Name, Email, Phone, Role } = selectedMember;

        try {
            const response = await api.put(`/admin/${selectedMember._id}`, {
                Name: Name,
                Email: Email,
                Phone: Phone,
                Role: Role,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            toast.success(response.data.message);
            getMembersBycompany();
            setIsModalOpen(false);
        } catch (error) {
            toast.error(error.response.data.message || "Error updating user");
            console.error(error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await api.post(`/admin/create-user`, formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            toast.success(response.data.message);
            getMembersBycompany();
            setOpen(false);
            setFormData({
                name: '',
                phonenumber: '',
                email: '',
                Role: '',
            })

        } catch (error) {
            toast.error(error?.response?.data?.error || "Something went wrong");
            console.error(error);
        } finally {
            setLoading(false); // Stop loading
        }    
    };

    const handleDelete = async (id) => {
        setLoading(true);
        if (userId === id) {
            toast.warning("You can't delete your own account");
            return;
        }
        try {
            const response = await api.delete(`/admin/${userId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            toast.success(response.data.message);
            getMembersBycompany();

        } catch (error) {
            toast.error(error.response.message);
            console.error(error);
        }
        finally {
            setLoading(false);
        }
    };

    const getMembersBycompany = useCallback(async () => {
        setDataLoading(true); // Set loading state to true before fetching
        try {
            const response = await api.post(`/organizations/members`, {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: {
                        page: page + 1,
                        limit: rowsPerPage,
                        search: search,
                        filter: "all",
                    },
                });

            setMembers(response.data.data);
            setTotalDocuments(response.data.totalDocuments);
        } catch (error) {
            console.log(error);
        } finally {
            setDataLoading(false); // Set loading state to false after fetching
        }
    }, [page, rowsPerPage, search, token]);

    useEffect(() => {
        if (token) {
            getMembersBycompany();
        }
    }, [getMembersBycompany, token])

    if (permissionsLoading) return <Loader />;

    return (
        <>  
        <Navbar
            title="Members"
        />
            <Box sx={{ padding: "2rem" }}>
                <Box sx={{ 
                    display: "flex", 
                    flexDirection: "column", 
                    gap: "1rem", 
                    padding: "2rem",
                    backgroundColor: "white", 
                    border: "1px solid #E0E0E0",
                    borderRadius: "8px",
                    overflow: "hidden",
                    position: "relative",
                    minHeight: "200px" 
                }}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 2,
                            flexWrap: "wrap",
                            gap: 1,
                        }}
                        >
                        <TabHeader
                            title="Members"
                            subtitle="See all members associated with the company."
                        />
                    {permissions?.includes("view_company_member") ?
                        <>
                            <Box
                                sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 2,
                                flexWrap: "wrap",
                                }}
                            >
                                <TextField
                            placeholder="Search by name, email or member ID"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            InputProps={{
                                startAdornment: (
                                <InputAdornment position="start">
                                    <SearchOutlined sx={{ color: "#999", width: 20, height: 20 }} />
                                </InputAdornment>
                                ),
                            }}
                            sx={{
                                ...textFieldSx,
                                width: "22rem",         // Adjust width to fit the placeholder fully
                                minWidth: "16rem",      // Prevent it from shrinking too much
                                flexShrink: 0,          // Prevent it from compressing in flex
                                input: {
                                overflow: "visible",  // Ensure text isn't clipped
                                },
                            }}
                            />

                            {permissions && permissions?.includes("add_company_member") &&
                                <Button
                                    sx={ButtonSx}
                                    onClick={() => setOpen(true)}
                                    startIcon={<Add/>}
                                    >
                                    Add Member
                                    </Button>
                            }
                    </Box>
                    {/* Table to display members */}
                    <TableContainer
                        sx={{
                            border: '1px solid #e6e7eb',
                            borderRadius: '8px',
                            overflow: 'hidden',
                            width: '100%',
                            mb: 6,
                        }}
                        >
                        {dataLoading ? (
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    height: '400px',
                                }}
                            >
                                <CircularProgress />
                            </Box>
                        ) : members.length > 0 ? (
                            <>
                            <Table sx={{ minWidth: 600 }} aria-label="members table">
                                <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', color: '#777780' }}>Name</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', color: '#777780' }}>Member ID</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', color: '#777780' }}>Email</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', color: '#777780' }}>Role</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', color: '#777780' }}>Action</TableCell>
                                </TableRow>
                                </TableHead>
                                <TableBody>
                                {members.map((member) => (
                                    <TableRow key={member._id} sx={{ height: '64px' }}>
                                        <TableCell sx={{ fontWeight: 600, color: '#000' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '.5rem', flexDirection: 'row' }}>
                                            <Avatar
                                                src={member.ProfilePicture}
                                                sx={{ width: 30, height: 30 }}
                                            />
                                            {member.Name}
                                            </Box>
                                        </TableCell>
                                        <TableCell>{member._id}</TableCell>
                                        <TableCell>{member.Email}</TableCell>
                                        <TableCell>{member.Role}</TableCell>
                                        <TableCell>
                                            <Edit
                                            sx={{ cursor: 'pointer', mr: 1 }}
                                            onClick={() => handleEditUser(member)}
                                            />
                                            <Delete
                                            sx={{ cursor: 'pointer' }}
                                            onClick={() => {
                                                setDeleteModal(true);
                                                setUserId(member._id);
                                            }}
                                            />
                                        </TableCell>
                                    </TableRow>

                                ))}
                                </TableBody>
                            </Table>

                            <TablePagination
                                component="div"
                                count={totalDocuments}
                                page={page}
                                onPageChange={(e, newPage) => setPage(newPage)}
                                rowsPerPage={rowsPerPage}
                                onRowsPerPageChange={(e) => {
                                setRowsPerPage(parseInt(e.target.value, 10));
                                setPage(0);
                                }}
                                sx={{ mx: 3 }}
                            />
                            </>
                        ) : (
                            <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '400px',
                            }}
                            >
                            <Typography variant="body1">No members found. Add a new member to get started.</Typography>
                            </Box>
                        )}
                    </TableContainer>
                        </>: 
                        <Box
                            sx={{
                            display: "flex",
                            justifyContent: "center",
                            width: "100%",
                            height: "70dvh",
                            }}
                        >
                            <NoDataFound
                                title="Insufficient Permissions"
                                subtitle="You do not have permission to view company members."
                            />
                        </Box>
                    }
                    </Box>
                    {/* Modal for adding new member */}
                    {open && 
                    <Modal
                        open={open}
                        onClose={() => setOpen(false)}
                        aria-labelledby="add-member-modal"
                        aria-describedby="modal-to-add-member"
                    >
                        <Box sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: 480,
                            bgcolor: 'background.paper',
                            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                            borderRadius: '16px',
                            p: 4,
                            outline: 'none',
                        }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                                <Typography id="add-member-modal" variant="h6" component="h6" sx={{ fontWeight: 700, fontSize: '1.25rem' }}>
                                    Add Member
                                </Typography>
                                <IconButton onClick={() => setOpen(false)} size="small" sx={{ p: 0 }}>
                                    <Close fontSize="small" />
                                </IconButton>
                            </Box>
                            {/* Form to add a new member */}
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                                {/* Name input */}
                                <TextField
                                    placeholder="Enter Name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    fullWidth
                                    required
                                    sx={textFieldSx}
                                    error={!!nameError} // Set to true if there's an error
                                    helperText={nameError} // Display the error message
                                />
                                {/* Phone number input */}
                                <Box sx={{
                                    display:'flex',
                                    flexDirection:'column',
                                    gap:0.5
                                }}>
                                    <PhoneInput
                                        country={"us"}
                                        value={formData.phonenumber}
                                        onChange={(value, country) => handlePhoneNumberInputChange(value, country)}
                                        inputStyle={phoneNumberStyleSx.inputStyle}
                                        buttonStyle={phoneNumberStyleSx.buttonStyle}
                                        containerStyle={phoneNumberStyleSx.containerStyle}
                                        inputProps={phoneNumberStyleSx.inputProps(error)}
                                    />
                                    {error && (
                                        <p style={{ color: "red", marginTop: "0.5rem", fontSize: "14px" }}>
                                            {error}
                                        </p>
                                    )}
                                </Box>
                                    {/* Email input */}
                                <TextField
                                    placeholder="Enter Email Address"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    fullWidth
                                    required
                                    type="email"
                                    sx={textFieldSx}
                                />
                                {/* Role selection */}
                                <FormControl fullWidth size="small">
                                    <TextField
                                        name="Role"
                                        value={formData.Role}
                                        onChange={handleChange}
                                        required
                                        select
                                        size="small"
                                        sx={textFieldSx}
                                        SelectProps={{
                                            displayEmpty: true,
                                            }}
                                        inputProps={{
                                        'aria-label': 'Select Category',
                                        }}
                                    >
                                    <MenuItem value="">
                                        <span style={{ color: '#9e9e9e' }}>
                                        Select the user Role (e.g. Admin, User)
                                        </span>
                                    </MenuItem>
                                        {["SuperAdmin", "Admin", "User"]
                                            .filter(role =>
                                                userRole === "SuperAdmin" ||
                                                (userRole === "Admin" && role !== "SuperAdmin") ||
                                                (userRole === "User" && role === "User")
                                            )
                                            .map(role => (
                                                <MenuItem key={role} value={role}>{role}</MenuItem>
                                            ))
                                        }
                                    </TextField>
                                </FormControl>
                                {/* Submit button */}
                                    <Button
                                        type="submit"
                                        disabled={loading || nameError || !formData.phonenumber || !!error}
                                        variant="contained"
                                        sx={ButtonSx}
                                    >
                                        {loading ? <CircularProgress size={20} color="inherit" /> : "Add Member"}
                                    </Button>
                                </form>
                            </Box>
                        </Box>
                    </Modal>
                    }

                    {/* Modal for updating member */}
                    {isModalOpen && (
                        <Modal
                            open={isModalOpen}
                            onClose={() => setIsModalOpen(false)}
                            aria-labelledby="update-member-modal"
                            aria-describedby="modal-to-update-member"
                            >
                            <Box sx={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: 480,
                                bgcolor: 'background.paper',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                                borderRadius: '16px',
                                p: 4,
                                outline: 'none',
                            }}>
                                {/* Header of the modal */}
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                                    <Typography id="update-member-modal" variant="h6" component="h6" sx={{ fontWeight: 700, fontSize: '1.25rem' }}>
                                        Update Member Details
                                    </Typography>
                                    <IconButton onClick={() => setIsModalOpen(false)} size="small" sx={{ p: 0 }}>
                                        <Close fontSize="small" />
                                    </IconButton>
                                </Box>
                                {/* Form to update member details */}
                                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                    <form onSubmit={updateUser} style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                                        <TextField
                                            sx={textFieldSx}
                                            name="Name"
                                            value={selectedMember.Name}
                                            onChange={handleInputChange}
                                            fullWidth
                                            placeholder={selectedMember.Name}
                                        />
                                        {/* Phone number input */}
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                            <PhoneInput
                                                country="us"
                                                value={selectedMember.Phone}
                                                onChange={(value, country) => handlePhoneNumberInputChange(value, country)}
                                                inputStyle={phoneNumberStyleSx.inputStyle}
                                                buttonStyle={phoneNumberStyleSx.buttonStyle}
                                                containerStyle={phoneNumberStyleSx.containerStyle}
                                                inputProps={phoneNumberStyleSx.inputProps(error)}
                                            />
                                            {error && (
                                                <p style={{ color: "red", marginTop: "0.5rem", fontSize: "14px" }}>
                                                    {error}
                                                </p>
                                            )}
                                        </Box>
                                        {/* Email input */}
                                        <TextField
                                            name="Email"
                                            value={selectedMember.Email}
                                            onChange={handleInputChange}
                                            fullWidth
                                            type="email"
                                            sx={textFieldSx}
                                            placeholder={selectedMember.Email}
                                        />
                                        {/* Role selection */}
                                        <FormControl fullWidth size="small">
                                            <TextField
                                                sx={textFieldSx}
                                                name="Role"
                                                value={selectedMember.Role}
                                                onChange={handleInputChange}
                                                label={selectedMember.Role}
                                                select
                                            >
                                                {["SuperAdmin", "Admin", "User"]
                                                    .filter(role =>
                                                        userRole === "SuperAdmin" ||
                                                        (userRole === "Admin" && role !== "SuperAdmin") ||
                                                        (userRole === "User" && role === "User")
                                                    )
                                                    .map(role => (
                                                        <MenuItem key={role} value={role}>
                                                            {role}
                                                        </MenuItem>
                                                    ))
                                                }
                                            </TextField>
                                        </FormControl>
                                        {/* Submit button */}
                                        <Button 
                                            type="submit" 
                                            sx={ButtonSx}
                                            disabled={error}
                                        >
                                            Update Member
                                        </Button>
                                    </form>
                                </Box>
                            </Box>
                        </Modal>
                    )}
                    {/* Delete member modal */}
                    <DeleteMemberModal
                        open={deleteModal}
                        handleClose={() => setDeleteModal(false)}
                        handleDelete={handleDelete}
                        userId={userId}
                        loading={loading}
                    />

                </Box>
            </Box>
        </>
    )
}

export default Member